import { handleActions } from 'redux-actions';

import * as actions from './actions';

export const oInitialState = {
  checkoutSummaryItems: [],
  checkoutTotal: 0,
  email: '',
  address: '',
  dadTransactionId: '',
  aCart: [],
};

const reducer = handleActions(
  {
    [actions.update]: (state, action) => ({
      ...state,
      ...action.payload,
      _lastUpdated: Date.now(),
    }),
    [actions.reset]: () => oInitialState,
    [actions.cart.addItem]: (state, action) => ({
      ...state,
      aCart: [...state.aCart, action.payload],
    }),
    [actions.cart.removeItem]: (state, action) => {
      const sIdToRemove = action.payload;
      const aCartWithoutItem = state.aCart.filter(
        (oItem) => oItem.sId !== sIdToRemove
      );
      return {
        ...state,
        aCart: aCartWithoutItem,
      };
    },
  },
  oInitialState,
  { prefix: 'Checkout' }
);

export default reducer;
